module.exports = __webpack_public_path__ + "img/home2.e2ed7692.jpg";